import { addMessages } from '@hana/i18n';

// Khoá chuỗi ngăn kéo thêm / sửa / dán và hộp lịch sử của Thiết lập giá (SetupDrawer.tsx). Mã phí, mã hãng, dữ liệu mẫu không dịch.
addMessages('vi', {
  'sd.noWrite': 'Chưa bật ghi Thiết lập giá',
  'sd.close': 'Đóng',
  'sd.cancel': 'Huỷ',
  'sd.need': 'Nhập {v}',
  'sd.quick': 'Mẫu nhanh',
  'sd.editT': 'Sửa · {v}',
  'sd.add': 'Thêm',
  'sd.saveNew': 'Lưu phiên bản mới',
  'sd.lccT': 'Thêm local charge', 'sd.lccL': 'Chọn hãng và mã LocalChargeCode (TypeCargo_Hãng_AMS/Non-AMS).',
  'sd.hubT': 'Thêm cảng chuyển tải', 'sd.hubL': 'Áp cho một POD hoặc nhiều POD cùng vùng.',
  'sd.tarT': 'Mã phí dịch vụ', 'sd.tarL': 'Mã, tên VN / EN, nhóm, đơn vị, giá 20′ / 40′, chi hộ (không VAT), thứ tự, mặc định vào job.',
  'sd.cusT': 'Đặt giá phụ phí riêng cho khách', 'sd.cusL': 'Chọn khách (ShortName) và mã phí trong thư viện.',
  'sd.ctryT': 'Thêm cảng', 'sd.ctryL': 'UN/LOCODE 5 ký tự; quốc gia tự nhận từ 2 ký tự đầu.',
  'sd.pasteT': 'Dán bảng Excel local charge',
  'sd.pasteL': 'Dán nguyên bảng (Ctrl V). Hệ thống tách cột mã · tên · đơn vị · 20′ · 40′, xem trước rồi mới ghi.',
  'sd.pasteK': 'Nội dung dán',
  'sd.pastePreview': 'Xem trước & ghi',
  'sd.pasteOk': 'Đã đọc {n} dòng · xem trước sẵn sàng',
  'sd.fCode': 'LocalChargeCode', 'sd.fCarrier': 'Hãng', 'sd.fSide': 'Phía (POL / POD)', 'sd.fCharge': 'Mã phí', 'sd.fNameEn': 'Tên (EN)', 'sd.fUnit': 'Đơn vị', 'sd.fValid': 'Hiệu lực từ',
  'sd.fPod': 'POD áp dụng', 'sd.fHub': 'Cảng chuyển tải (hub)', 'sd.fTransit': 'Transit chặng 2 (ngày)', 'sd.fNote': 'Ghi chú',
  'sd.fGroup': 'Nhóm', 'sd.fNameVn': 'Tên VN', 'sd.fNameEn2': 'Tên EN', 'sd.fCur': 'Tiền tệ',
  'sd.fCustomer': 'Khách', 'sd.fKind': 'Loại', 'sd.kindOwn': 'Giá riêng',
  'sd.fLocode': 'UN/LOCODE', 'sd.fPort': 'Tên cảng', 'sd.fCountry': 'Quốc gia', 'sd.fRegion': 'Vùng', 'sd.fHubDef': 'Cảng chuyển tải mặc định',
  'sd.histT': 'Lịch sử thay đổi', 'sd.histL': 'Mỗi lần sửa lưu một phiên bản; xem lại hoặc khôi phục.',
  'sd.h1': 'Pricing - Hana Logistics · sửa THC 40′', 'sd.h2': 'David - Hana Logistics · thêm EMI', 'sd.h3': 'Nhập lô IMP-MSC-261001080000', 'sd.h4': 'Philip - Hana Logistics · thêm BLS (COSCO)',
});
addMessages('en', {
  'sd.noWrite': 'Price setup writes are not enabled yet',
  'sd.close': 'Close',
  'sd.cancel': 'Cancel',
  'sd.need': 'Enter {v}',
  'sd.quick': 'Quick templates',
  'sd.editT': 'Edit · {v}',
  'sd.add': 'Add',
  'sd.saveNew': 'Save new version',
  'sd.lccT': 'Add local charge', 'sd.lccL': 'Pick the carrier and LocalChargeCode (TypeCargo_Carrier_AMS/Non-AMS).',
  'sd.hubT': 'Add transhipment hub', 'sd.hubL': 'Applies to one POD or several PODs in the same region.',
  'sd.tarT': 'Service fee code', 'sd.tarL': 'Code, VN / EN name, group, unit, 20′ / 40′ price, pass-through (no VAT), order, default into job.',
  'sd.cusT': 'Set customer-specific surcharge', 'sd.cusL': 'Pick the customer (ShortName) and a fee code from the library.',
  'sd.ctryT': 'Add port', 'sd.ctryL': '5-character UN/LOCODE; the country is taken from the first 2 characters.',
  'sd.pasteT': 'Paste local charge Excel table',
  'sd.pasteL': 'Paste the whole table (Ctrl V). Columns code · name · unit · 20′ · 40′ are split, preview before saving.',
  'sd.pasteK': 'Pasted content',
  'sd.pastePreview': 'Preview & save',
  'sd.pasteOk': 'Read {n} rows · preview ready',
  'sd.fCode': 'LocalChargeCode', 'sd.fCarrier': 'Carrier', 'sd.fSide': 'Side (POL / POD)', 'sd.fCharge': 'Charge code', 'sd.fNameEn': 'Name (EN)', 'sd.fUnit': 'Unit', 'sd.fValid': 'Valid from',
  'sd.fPod': 'Applied POD', 'sd.fHub': 'Transhipment hub', 'sd.fTransit': 'Leg-2 transit (days)', 'sd.fNote': 'Note',
  'sd.fGroup': 'Group', 'sd.fNameVn': 'VN name', 'sd.fNameEn2': 'EN name', 'sd.fCur': 'Currency',
  'sd.fCustomer': 'Customer', 'sd.fKind': 'Type', 'sd.kindOwn': 'Own price',
  'sd.fLocode': 'UN/LOCODE', 'sd.fPort': 'Port name', 'sd.fCountry': 'Country', 'sd.fRegion': 'Region', 'sd.fHubDef': 'Default transhipment hub',
  'sd.histT': 'Change history', 'sd.histL': 'Every edit saves a version; review or restore it.',
  'sd.h1': 'Pricing - Hana Logistics · edited THC 40′', 'sd.h2': 'David - Hana Logistics · added EMI', 'sd.h3': 'Imported batch IMP-MSC-261001080000', 'sd.h4': 'Philip - Hana Logistics · added BLS (COSCO)',
});
